





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Icon, Toast, Popup } from 'vant';
import Poster from './Poster.vue';
import { getBaseinfo } from '@/api/api';
import { getUserType } from '../api/index';
import * as config from '../config';

Vue.use(Icon)
  .use(Toast)
  .use(Popup);
enum EUserStatus {
  'unRegistered' = 201,
  'reviewing' = 202,
  'reviewed' = 203,
}
@Component({
  components: {
    Poster,
  },
})
export default class FloatLikeBtn extends Vue {
  @Prop() activePost!: any;
  // @Prop() posterData!: any;
  @Prop() showZan!: any;
  @Prop({ default: false }) goUser!: any;
  option = config.OPTHINES;
  showCanvas = false;
  showModal = false;
  userStatus: any = null;
  baseInfo = {};
  @Watch('$route')
  routeChange() {
    this.showModal = false;
  }
  created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    getBaseinfo(this.option.voteName).then((res: any) => {
      this.baseInfo = res.data;
    });
  }
  // enterUploading() {
  //   // 直接跳转页面
  //   window.location.href = 'https://wap.cqcb.com/shangyou_news/composition';
  // }
  public enterUploading() {
    if (
      window.gettoken() &&
      window.gettoken() !== '' &&
      window.gettoken() !== 'null'
    ) {
      // 判断该作文用户状态
      getUserType().then((res) => this.enterUserType(res));
    } else {
      if (window.udid) {
        // APP环境用户未登录
        console.log('用户未登录');
        if (parseFloat(window.version) >= 4.5) {
          const option = {
            action: 'mUserLogin',
            data: '请先登录上游账号',
          };
          window.handleMessage(JSON.stringify(option));
        } else {
          window.location.href = 'client:logout';
        }
      } else {
        // WAP环境跳转作文首页
        setTimeout(() => {
          window.location.href =
            'https://wap.cqcb.com/shangyou_news/composition/';
        }, 200);
      }
    }
  }
  public enterUserType(res: any) {
    console.log('res.statusCode', res.statusCode);
    this.userStatus = Number(res.statusCode);

    if (this.userStatus === EUserStatus.unRegistered) {
      // 未注册作文用户前往作文注册页面
      console.log('不是作文用户');
      Toast('请完善作文用户资料');
      setTimeout(() => {
        window.location.href =
          'https://wap.cqcb.com/shangyou_news/composition/UserCenter';
      }, 200);
    } else if (this.userStatus === EUserStatus.reviewing) {
      // 审核状态弹窗提示账户审核中，无法上传作文
      this.toggleDialog();
    } else if (this.userStatus === EUserStatus.reviewed) {
      // 账号审核通过，跳转至发布作文页面
      console.log('是作文用户');
      window.location.href =
        'https://wap.cqcb.com/shangyou_news/composition/contribute';
    }
  }
  public toggleDialog() {
    this.showModal = !this.showModal;
  }
}
